import React, { FC, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';
import ArrowUpwardSharpIcon from '@material-ui/icons/ArrowUpwardSharp';

import Styled from './style';
import { Typography } from '../../../../shared/typography';
import { Message } from '../message';
import colors from '../../../../assets/colors';
import { ADD_COMMENT_TO_SHARED_SUCCESS } from '../../../../store/SharedSnap/types';

type IProps = {
	comments: any;
	comment: string;
	user: any;
	type: string;
	handleChange(e: React.ChangeEvent<HTMLInputElement>): void;
	sendMessage(): void;
};

const Comments: FC<IProps> = ({
	comments,
	comment,
	user,
	type,
	handleChange,
	sendMessage,
}) => {
	const messagesEndRef = useRef<any>(null);
	const sections = useMemo(() => {
		const uniqueDays = Array.from(
			new Set(
				comments.map((comment: any) => moment(comment.createdAt).dayOfYear())
			)
		).sort((a: any, b: any) => a - b);
		return uniqueDays.map((day: any) => {
			const chartsByDay = comments
				.filter((comment: any) => moment(comment.createdAt).dayOfYear() === day)
				.sort((a: any, b: any) =>
					moment.utc(a.createdAt).diff(moment.utc(b.createdAt))
				);
			return {
				title: moment().dayOfYear(day).format('D MMMM'),
				data: chartsByDay,
			};
		});
	}, [comments]);

	useEffect(() => {
		if (type === ADD_COMMENT_TO_SHARED_SUCCESS) {
			messagesEndRef?.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [type]);

	return (
		<Styled.Wrapper>
			<Styled.TopContent>
				<Styled.Block>
					{sections.length ? (
						sections.map((section, i) => (
							<div key={i}>
								<Styled.SectionTitle>
									<Typography
										text={section.title}
										size="medium"
										color="btnTextGrey"
									/>
								</Styled.SectionTitle>
								{section.data.map((message: any, i: any) => (
									<Message
										key={i}
										item={message}
										mine={message.userId === user?._id}
									/>
								))}
							</div>
						))
					) : (
						<Styled.SectionTitle>
							<Typography
								text={'No comments'}
								size="medium"
								color="btnTextGrey"
							/>
						</Styled.SectionTitle>
					)}
					<div ref={messagesEndRef} />
				</Styled.Block>
			</Styled.TopContent>
			<Styled.BottomContent>
				<Styled.Input
					placeholder={'Comment...'}
					onChange={handleChange}
					value={comment}
				/>
				<Styled.Button onClick={sendMessage} active={!!comment.trim()}>
					<ArrowUpwardSharpIcon
						style={{ color: colors.white }}
						fontSize="large"
					/>
				</Styled.Button>
			</Styled.BottomContent>
		</Styled.Wrapper>
	);
};

export default Comments;
